import api from '@src/api/clients';

const BASE_URL = 'dashboard/invoices/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

export const listInvoices = (params = {}) =>
  api.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export const retrieveInvoice = (invoiceId, params = {}) =>
  api.request({ url: `${BASE_URL}${invoiceId}/`, method: 'GET', payload: cleanParams(params) });

export const getClientChannelBreakdown = (params = {}) =>
  api.request({
    url: `${BASE_URL}client-channel-breakdown/`,
    method: 'GET',
    payload: cleanParams(params),
  });

export const getClientSpendPreview = (params = {}) =>
  api.request({
    url: `${BASE_URL}client-spend-preview/`,
    method: 'GET',
    payload: cleanParams(params),
  });

export const retrievePublicInvoice = (params = {}) =>
  api.request({
    url: `${BASE_URL}public/`,
    method: 'GET',
    payload: cleanParams(params),
    auth: false,
  });

export const retrievePublicPaymentIntent = (params = {}) =>
  api.request({
    url: `${BASE_URL}public-payment-intent/`,
    method: 'GET',
    payload: cleanParams(params),
    auth: false,
  });

export const downloadPublicInvoicePdf = ({ number, token }) =>
  api
    .request({
      url: `${BASE_URL}public-pdf/`,
      method: 'GET',
      payload: cleanParams({ number, token }),
      auth: false,
      options: { responseType: 'blob' },
    })
    .then((response) => response.data);

export const createInvoice = (payload) =>
  api.request({ url: BASE_URL, method: 'POST', payload });

export const updateInvoice = (invoiceId, payload) =>
  api.request({ url: `${BASE_URL}${invoiceId}/`, method: 'PATCH', payload });

export const deleteInvoice = (invoiceId) =>
  api.request({ url: `${BASE_URL}${invoiceId}/`, method: 'DELETE' });

export const downloadInvoicePdf = (invoiceId) =>
  api
    .request({
      url: `${BASE_URL}${invoiceId}/pdf/`,
      method: 'GET',
      options: { responseType: 'blob' },
    })
    .then((response) => response.data);

export const sendInvoice = (invoiceId, payload = {}) =>
  api.request({ url: `${BASE_URL}${invoiceId}/send/`, method: 'POST', payload });

export const markInvoicePaid = (invoiceId, payload = {}) =>
  api.request({ url: `${BASE_URL}${invoiceId}/mark-paid/`, method: 'POST', payload });

export const bulkGenerateInvoices = (payload) =>
  api.request({ url: `${BASE_URL}bulk-generate/`, method: 'POST', payload });

export const uploadInvoiceAttachment = (invoiceId, formData) =>
  api.request({
    url: `${BASE_URL}${invoiceId}/attachments/`,
    method: 'POST',
    payload: formData,
    multipart: true,
  });

export const retrieveInvoiceClientSettings = (clientId) =>
  api.request({ url: `dashboard/clients/${clientId}/`, method: 'GET' });

export const updateInvoiceClientSettings = (clientId, payload) =>
  api.request({ url: `dashboard/clients/${clientId}/`, method: 'PATCH', payload });

export const listInvoiceBillingContacts = (clientId, params = {}) =>
  api.request({
    url: 'dashboard/client-pocs/',
    method: 'GET',
    payload: cleanParams({ client_id: clientId, ...params }),
  });

export const createInvoiceBillingContact = (payload) =>
  api.request({ url: 'dashboard/client-pocs/', method: 'POST', payload });

export const updateInvoiceBillingContact = (contactId, payload) =>
  api.request({ url: `dashboard/client-pocs/${contactId}/`, method: 'PATCH', payload });

export const deleteInvoiceBillingContact = (contactId) =>
  api.request({ url: `dashboard/client-pocs/${contactId}/`, method: 'DELETE' });

export default {
  listInvoices,
  retrieveInvoice,
  getClientChannelBreakdown,
  getClientSpendPreview,
  retrievePublicInvoice,
  retrievePublicPaymentIntent,
  downloadPublicInvoicePdf,
  downloadInvoicePdf,
  createInvoice,
  updateInvoice,
  deleteInvoice,
  sendInvoice,
  markInvoicePaid,
  bulkGenerateInvoices,
  uploadInvoiceAttachment,
  retrieveInvoiceClientSettings,
  updateInvoiceClientSettings,
  listInvoiceBillingContacts,
  createInvoiceBillingContact,
  updateInvoiceBillingContact,
  deleteInvoiceBillingContact,
};
